export default __webpack_public_path__ + "static/media/m-sub-banner-num-5.f109c407.svg";